import React, { useState } from "react"
import { QuestionnaireFormContext } from "."
import { useFilter } from "../../../hooks/filter"
import { formatFilter } from "../pages/main/constants"
import { FilterProps } from "../../../hooks/filter/typing"
import { removeAllReference } from "../../../utils/methods/removedReference"
import { ItemsInput } from "../pages/main/typing/types"

const QuestionnaireFormProvider = ({ children }: { children: React.ReactElement }) => {
    const [state, setState] = useState<any>({})
    const [allDepartments, setAllDepartments] = useState<any[]>([])
    const [itemsSearch, setItemsSearch] = useState<ItemsInput>({})
    const externalValidation: FilterProps['externalValidation'] = ({
        name,
        body,
        value: values,
        setFilterData,
    }) => {
        let copyBody: Record<string, any> = removeAllReference(body)

        if (name === 'areas') {
            const { departments: departmentsData } = copyBody
            const newDepartments = departmentsData?.filter((e: any) =>
                values.find((e2: any) => e2.value == e.areaId)
            )
            let arrayChilds: any[] = []

            values?.forEach((e: any) => {
                const id = e.value
                const childs = allDepartments.filter((child) => child.areaId == id)
                arrayChilds.push(...childs)
            })
            setItemsSearch((prev) => ({
                ...prev,
                departments: arrayChilds,
            }))
            setFilterData((prev) => ({
                ...prev,
                departments: newDepartments,
            }))

            copyBody = {
                ...copyBody,
                departments: newDepartments,
            }
        }

        return copyBody
    }

    const paginationMain = useFilter({
        formatFilter,
        externalValidation
    })

    return (
        <QuestionnaireFormContext.Provider
            value={{
                state,
                setState,
                paginationMain,
                allDepartments,
                itemsSearch,
                setAllDepartments,
                setItemsSearch,
            }}
        >{children}</QuestionnaireFormContext.Provider>
    )
}

export { QuestionnaireFormProvider }